"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var types_1 = require("./types");
var types_2 = require("@wix/social-groups-api/dist/src/types");
var social_groups_api_1 = require("@wix/social-groups-api");
function getGroupSEOItemType(routeParams) {
    if (routeParams.commentId) {
        return types_1.GroupSEOItemType.GROUPS_COMMENT;
    }
    var pages = {
        discussion: types_1.GroupSEOItemType.GROUPS_FEED,
        about: types_1.GroupSEOItemType.GROUPS_ABOUT,
        media: types_1.GroupSEOItemType.GROUPS_MEDIA,
        members: types_1.GroupSEOItemType.GROUPS_MEMBERS,
    };
    var currentPage = pages[routeParams.activeTab];
    if (routeParams.feedItemId) {
        return types_1.GroupSEOItemType.GROUPS_POST;
    }
    return currentPage;
}
exports.getGroupSEOItemType = getGroupSEOItemType;
function getGroupSEOCustomTabNames(apps) {
    var _a;
    var groupAppKeyToTab = (_a = {},
        _a[types_2.ApiTypes.v1.GroupAppKey.MEMBERS_APP] = 'members',
        _a[types_2.ApiTypes.v1.GroupAppKey.FEED_APP] = 'discussion',
        _a[types_2.ApiTypes.v1.GroupAppKey.ABOUT_APP] = 'about',
        _a[types_2.ApiTypes.v1.GroupAppKey.GALLERY_APP] = 'media',
        _a);
    return Object.entries(apps).reduce(function (acc, _a) {
        var _b;
        var _c = tslib_1.__read(_a, 2), key = _c[0], value = _c[1];
        return tslib_1.__assign({}, acc, (_b = {}, _b[groupAppKeyToTab[key]] = value.customName || '', _b));
    }, {});
}
exports.getGroupSEOCustomTabNames = getGroupSEOCustomTabNames;
function groupWithPlainTextContent(srcGroup) {
    var group = tslib_1.__assign({}, srcGroup);
    if (group.details) {
        group.details = tslib_1.__assign({}, srcGroup.details, { description: draftJsStringToPlainText(group.details.description) });
    }
    return group;
}
exports.groupWithPlainTextContent = groupWithPlainTextContent;
function feedItemsWithPlainTextContent(srcFeedItems) {
    return srcFeedItems.map(feedItemWithPlainTextContent);
}
exports.feedItemsWithPlainTextContent = feedItemsWithPlainTextContent;
function feedItemWithPlainTextContent(feedItem) {
    return tslib_1.__assign({}, feedItem, { entity: {
            body: feedItem.entity.body.contentType === types_2.SocialApiTypes.ContentType.DRAFTJS
                ? draftJsStringToPlainText(feedItem.entity.body.content)
                : feedItem.entity.body.content,
        } });
}
exports.feedItemWithPlainTextContent = feedItemWithPlainTextContent;
function feedItemImages(feedItem) {
    return (feedItem.attachments || []).filter(isImage).map(function (imgAttachment) { return (tslib_1.__assign({ url: social_groups_api_1.MediaApi.wixStaticImageUrl(imgAttachment.uri) }, imgAttachment.pixelDimensions)); });
}
exports.feedItemImages = feedItemImages;
function isImage(attachment) {
    return attachment.mediaType === types_2.SocialApiTypes.MediaType.IMAGE;
}
function draftJsStringToPlainText(draftJs) {
    try {
        var content = JSON.parse(draftJs);
        var texts = content.blocks.map(function (block) { return block.text; });
        return texts.join('\n').trim();
    }
    catch (e) {
        // console.error(e);
        return draftJs;
    }
}
//# sourceMappingURL=utils.js.map